import { RSOverviewPageModel } from '../../api.types';

export const EMIR_RESPONSE_MODEL_STANDARD = 'standard' as const;
export const EMIR_RESPONSE_MODEL_DETAILED = 'detailed' as const;

export type EmirResponseModel =
  | typeof EMIR_RESPONSE_MODEL_STANDARD
  | typeof EMIR_RESPONSE_MODEL_DETAILED;

/** Normalised manco pie row (standard and detailed). */
export type EmirMancoSectionSummary = {
  key: string;
  label: string;
  pass: number;
  fail: number;
  percentage_pass: number;
};

/** Per-fund section metrics (detailed rows include `assets`). */
export type EmirFundSectionMetrics = {
  limit: number;
  value: number;
  percentage_value: number;
  status: string;
  assets?: Array<Record<string, unknown>>;
};

/** Fund row in `data.funds` (standard and detailed). */
export type EmirFundRow = {
  fund_name: string;
  fund_name_full: string;
} & {
  [sectionKey: string]: EmirFundSectionMetrics | string | undefined;
};

/** Shared fields on `OverviewPage.data` for both standard and detailed EMIR. */
export type EmirBreakdownPayloadBase = {
  emir_response_model: EmirResponseModel;
  manco: Record<string, unknown>;
  funds: EmirFundRow[];
  manco_section_summaries: EmirMancoSectionSummary[];
};

export type EmirStandardBreakdownPayload = EmirBreakdownPayloadBase & {
  emir_response_model: typeof EMIR_RESPONSE_MODEL_STANDARD;
  manco_limits?: Record<string, number>;
  sub_fund_limits?: Record<string, number>;
};

export type EmirDetailedBreakdownPayload = EmirBreakdownPayloadBase & {
  emir_response_model: typeof EMIR_RESPONSE_MODEL_DETAILED;
};

export type EmirBreakdownPayload =
  | EmirStandardBreakdownPayload
  | EmirDetailedBreakdownPayload;

/** Backend `OverviewPage` envelope from `get_EMIR_breakdown`. */
export type EmirOverviewPageModel = RSOverviewPageModel<EmirBreakdownPayload>;
